import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","overflow":"hidden"} }
const _hoisted_2 = {
  key: 0,
  class: "uploadDataBox comBox"
}
const _hoisted_3 = { class: "sliderBox" }
const _hoisted_4 = { style: {"font-size":"0.16rem","color":"#333333","font-weight":"bold"} }
const _hoisted_5 = { style: {"margin-top":"0.06rem"} }
const _hoisted_6 = { class: "image-slot" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"position":"absolute","bottom":"0","left":"0px","width":"300px","background-color":"rgba(51, 51,51 , .3)","height":"35px","z-index":"99","color":"#FFF","line-height":"35px"} }
const _hoisted_9 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_13 = { style: {"display":"flex","flex-wrap":"wrap","justify-content":"space-between","width":"100%"} }
const _hoisted_14 = { style: {"min-width":"300px","margin-right":"0.24rem","color":"#86909c","margin-bottom":"0.08rem"} }
const _hoisted_15 = { style: {"min-width":"300px","margin-right":"0.24rem","color":"#86909c","margin-bottom":"0.08rem"} }
const _hoisted_16 = { style: {"min-width":"300px","color":"#86909c","margin-bottom":"0.08rem"} }
const _hoisted_17 = { style: {} }
const _hoisted_18 = { style: {"height":"329px","width":"100%"} }
const _hoisted_19 = ["src"]
const _hoisted_20 = { style: {"display":"grid","grid-template-columns":"repeat(5, minmax(0, 1fr))","column-gap":"12px","row-gap":"12px","margin-top":"20px"} }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  class: "",
  style: {"display":"flex","justify-content":"center","align-items":"center","column-gap":"20px","margin-top":"20px"}
}

import { UploadFilled } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage, ElNotification, Message } from "element-plus";
import { Axios } from "../../../assets/js/ls_com_axios.js";
import { serverUrls } from "../../../assets/js/ls_tgServerUrls.js";

import { useRoute, useRouter } from "vue-router";

import { serverBaseUrl } from "../../../assets/js/ls_tgServerUrls.js";
interface RuleForm {
  name: string;
  radio: number;
  enterPlusPrice: ["sting", "number"];
  selfPrice: ["sting", "number"];
  enterPrice: ["sting", "number"];
  title: string;
  typeIds: [];
  images: [];
  files: [];
}
const percentageValue = 100;

export default /*@__PURE__*/_defineComponent({
  __name: 'materia_perfect',
  setup(__props) {

const router = useRouter();
const dialogVisible = ref(false);
const coverClick = () => {
  ruleForm.checkImg = ruleForm.showImage;
  dialogVisible.value = true;
}
const saveClick = () => {
  ruleForm.showImage = ruleForm.checkImg;
  dialogVisible.value = false;
}
const handleInput = (value) => {
  const selectId = document.querySelector("#selecttagsId");
  if (selectId) {
    selectId.setAttribute("maxLength", 10);
  }
};
handleInput();
const formSize = ref("default");
const ruleFormRef = ref<FormInstance>();
const progressValue = (percentage) =>
  percentage === 100 ? "100%" : `${percentage}%`;
/**
 * 分类下拉
 */
const options = ref([]);
Axios("get", "/fodder/video-types", {}, false, function (res) {
  const tree = buildTree(res.data.data);
  options.value = tree;
});

function buildTree(materials) {
  const tree = {};

  materials.forEach((material) => {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = { ...material, options: [] };
    } else {
      tree[id] = { ...material, options: tree[id].options };
    }

    if (!tree[parentId]) {
      tree[parentId] = { options: [] };
    }
    tree[parentId].options.push(tree[id]);
  });

  return tree[0].options;
}

/**
 * 表单提交
 **/
const route = useRoute();
const ruleForm = reactive<RuleForm>({
  enterPlusPrice: "",
  selfPrice: "",
  enterPrice: "",
  previewPath: "",
  tagIds: [],
  title: "",
  typeIds: [],
  images: [],
  file: route.query,
  filePath: route.query.url,
  fileName: route.query.name,
  files: [],
  checkImg: ""
});

const rules = reactive<FormRules<RuleForm>>({
  enterPlusPrice: [
    { required: true, message: "请输入企业Plus授权价格", trigger: "blur" },
  ],
  selfPrice: [{ required: true, message: "请输入作品定价", trigger: "blur" }],
  enterPrice: [
    { required: true, message: "请输入企业授权价格", trigger: "blur" },
  ],
  tagIds: [{ required: true, message: "请输入标签", trigger: "blur" }],
  typeIds: [{ required: true, message: "请输入分类", trigger: "blur" }],
  title: [{ required: true, message: "请输入标题", trigger: "blur" }],
});
let show = ref(false);
Axios("get", `/fodder/info/${route.query.id}`, {}, false, (res) => {
  if (res.data.code == 200) {
    show.value = false;
    let data = res.data.data;
    data.typeIds = data.typeIds ? data.typeIds.split(",").map(Number) : [];
    data.showImages = data.screenshot ? data.screenshot.split(",") : [];
    data.checkImg = data.showImage = data.showImage ? data.showImage : data.showImages.length ? data.showImages[0] : "";
    data.previewPath = data.previewPath ? data.previewPath : "";
    data.tagIds = data.tagIds ? data.tagIds.split(",") : [];
    let images = [];
    if (data.images) {
      data.images.forEach((item) => {
        images.push({
          url: item,
        });
      });
    }
    ruleForm.images2 = [];
    data.images = images;
    // data.file = data.
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        // 确保只遍历对象本身的属性，而不包括继承的属性
        ruleForm[key] = data[key];
      }
    }
    show.value = true;
    console.log(ruleForm);
  } else {
    ElMessage.error(res.data.msg);
  }
});

const onSubmit = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  let tagIdsString = "";
  if (ruleForm.tagIds.length != 0) {
    for (let i = 0; i < ruleForm.tagIds.length; i++) {
      if (i == ruleForm.tagIds.length - 1) {
        tagIdsString = tagIdsString + ruleForm.tagIds[i];
      } else {
        tagIdsString = tagIdsString + ruleForm.tagIds[i] + ",";
      }
    }
  }
  if (!ruleForm.showImage) {
    ElMessage({
      message: "请上传封面",
      type: "error",
    });
    return;
  }
  if (!ruleForm.previewPath) {
    ElMessage({
      message: "请上传预览视频",
      type: "error",
    });
    return;
  }
  await formEl.validate((valid, fields) => {
    if (valid) {
      let data = JSON.parse(JSON.stringify(ruleForm));
      data.typeIds = Array.isArray(data.typeIds)
        ? data.typeIds.join(",")
        : data.typeIds;
      data.tagIds = tagIdsString;
      data.tagIds = Array.isArray(data.tagIds)
        ? data.tagIds.join(",")
        : data.tagIds;
      data.materialType = "VIDEO";
      data.filePath = data.params.source_url;
      const urls = [];
      if (data.images.length != 0) {
        data.images.forEach((item) => {
          urls.push(item.url);
        });
      }

      let images = [...urls, ...ruleForm.images2];
      let new_images = [];
      if (images.length != 0) {
        images.forEach((item, index) => {
          if (item.indexOf("blob:") === -1) {
            new_images.push(item);
          }
        });
      }

      data.images = new_images;

      Axios("put", "/fodder", data, false, (res) => {
        console.log(res);
        if (res.data.code == 200) {
          router.go(-1);
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    }
  });
};

/**
 * upload_showImage上传路径
 * 封面上传成功  给ruleForm.showImage  赋值
 */
const upload_showImage = ref(serverBaseUrl + "/file/upload");

const onSuccessImages = (res) => {
  // console.log(res)
  show.value = false;
  if (res.code == 200) {
    ruleForm.images2.push(res.data.url);
    ElMessage({
      message: "上传成功",
      type: "success",
    });
    show.value = true;
  } else {
    ElMessage({
      message: "上传失败",
      type: "error",
    });
  }
};
const onSuccessShowImage = (res) => {
  ruleForm.files = [];
  if (res.code == 200) {
    ruleForm.showImage = res.data.url;
    ElMessage({
      message: "上传成功",
      type: "success",
    });
  } else {
    ElMessage({
      message: "上传失败",
      type: "error",
    });
  }
};
const onSuccessPreview = (res) => {
  ruleForm.files = [];
  if (res.code == 200) {
    ruleForm.previewPath = res.data.url;
    ElMessage({
      message: "上传成功",
      type: "success",
    });
  } else {
    ElMessage({
      message: "上传失败",
      type: "error",
    });
  }
};
const beforeUpload = (file, type) => {
  let maxSize = 6;
  if (type == "previewPath") {
    ruleForm.previewPath = "";
    maxSize = 20;
  }
  if (type == "images") {
    maxSize = 10;
  }
  const isLt = file.size / 1024 / 1024 < maxSize;
  if (!isLt) {
    ElMessage({
      message: `上传文件大小不能超过${maxSize}MB!`,
      type: "error",
    });
    return false;
  }
  return true;
};

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(show))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[27] || (_cache[27] = _createElementVNode("div", {
            class: "shiping",
            style: {"font-size":"0.14rem","color":"#333333","margin-bottom":"0.16rem"}
          }, " 视频 ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(ruleForm.title) + _toDisplayString(ruleForm.fileExt), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_progress, {
                percentage: percentageValue,
                format: progressValue
              })
            ])
          ]),
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: ruleForm,
            "label-width": "100px",
            rules: rules,
            class: "demo-ruleForm",
            size: formSize.value,
            "status-icon": "",
            "label-position": "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "封面",
                prop: "showImage",
                style: {"position":"relative"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: "upload-demo",
                    "before-upload": (file) => beforeUpload(file, 'image'),
                    accept: ".jpg,.png",
                    drag: "",
                    action: upload_showImage.value,
                    multiple: "",
                    "show-file-list": false,
                    "on-success": onSuccessShowImage,
                    limit: 1,
                    "list-type": "text",
                    "file-list": ruleForm.files
                  }, {
                    default: _withCtx(() => [
                      (ruleForm.showImage)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            style: {"height":"204px"},
                            src: ruleForm.showImage
                          }, {
                            error: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createElementVNode("div", { style: {"width":"0.2rem","height":"0.2rem","background":"url(data:image/png;base64,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)","background-size":"100%","background-repeat":"no-repeat"} }, null, -1)
                                  ])),
                                  _: 1
                                }),
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "el-upload__text" }, [
                                  _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333"} }, " 点击或拖拽文件到此处上传 "),
                                  _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 图片尺寸至少302*180 "),
                                  _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 支持JPG/PNG，不超过6MB ")
                                ], -1))
                              ])
                            ]),
                            _: 1
                          }, 8, ["src"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createElementVNode("div", { style: {"width":"0.2rem","height":"0.2rem","background":"url(data:image/png;base64,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)","background-size":"100%","background-repeat":"no-repeat"} }, null, -1)
                              ])),
                              _: 1
                            }),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "el-upload__text" }, [
                              _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333"} }, " 点击或拖拽文件到此处上传 "),
                              _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 图片尺寸至少302*180 "),
                              _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 支持JPG/PNG，不超过6MB ")
                            ], -1))
                          ])),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"flex":"1","text-align":"center","cursor":"pointer"} }, [
                            _createElementVNode("span", null, "本地上传")
                          ], -1)),
                          _cache[16] || (_cache[16] = _createElementVNode("div", { style: {} }, [
                            _createElementVNode("span", null, "|")
                          ], -1)),
                          _createElementVNode("div", {
                            onClick: _withModifiers(coverClick, ["stop"]),
                            style: {"flex":"1","text-align":"center","cursor":"pointer"}
                          }, _cache[14] || (_cache[14] = [
                            _createElementVNode("span", null, "推荐封面", -1)
                          ]))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["before-upload", "action", "file-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "预览视频",
                prop: "showImage"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: "upload-demo",
                    "before-upload": (file) => beforeUpload(file, 'previewPath'),
                    accept: ".mp4",
                    drag: "",
                    action: upload_showImage.value,
                    multiple: "",
                    "show-file-list": false,
                    "on-success": onSuccessPreview,
                    limit: 1,
                    "list-type": "text",
                    "file-list": ruleForm.files
                  }, {
                    default: _withCtx(() => [
                      (ruleForm.previewPath)
                        ? (_openBlock(), _createElementBlock("video", {
                            key: 0,
                            class: "video",
                            src: ruleForm.previewPath
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createElementVNode("div", { style: {"width":"0.2rem","height":"0.2rem","background":"url(data:image/png;base64,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)","background-size":"100%","background-repeat":"no-repeat"} }, null, -1)
                              ])),
                              _: 1
                            }),
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "el-upload__text" }, [
                              _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333"} }, " 点击或拖拽文件到此处上传 "),
                              _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 支持MP4，不超过20M ")
                            ], -1))
                          ]))
                    ]),
                    _: 1
                  }, 8, ["before-upload", "action", "file-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "标题",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.title) = $event)),
                    placeholder: "请输入标题",
                    maxlength: "40",
                    "show-word-limit": "",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "分类",
                prop: "typeIds"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_select, {
                      style: {"width":"100%"},
                      "max-collapse-tagIds": 6,
                      modelValue: ruleForm.typeIds,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.typeIds) = $event)),
                      "collapse-tagIds": "",
                      placeholder: "*请选择",
                      multiple: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            key: group.name,
                            label: group.name
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "标签",
                prop: "tagIds"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "tagType",
                    style: {"width":"100%"},
                    modelValue: ruleForm.tagIds,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.tagIds) = $event)),
                    clearable: "",
                    multiple: "",
                    "reserve-keyword": false,
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    id: "selecttagsId",
                    placeholder: "最多添加10个标签,每个标签最多10个字,按回车Enter创建标签",
                    "no-data-text": "",
                    onInput: handleInput
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "作品定价",
                prop: "selfPrice"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", null, "个人授权价格", -1)),
                      _createVNode(_component_el_input, {
                        oninput: "value=value.replace(/[^\\d.]/g, '')",
                        modelValue: ruleForm.selfPrice,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.selfPrice) = $event)),
                        placeholder: "请输入个人授权价格",
                        clearable: ""
                      }, {
                        append: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("元")
                        ])),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", null, "企业授权价格", -1)),
                      _createVNode(_component_el_input, {
                        modelValue: ruleForm.enterPrice,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.enterPrice) = $event)),
                        oninput: "value=value.replace(/[^\\d.]/g, '')",
                        placeholder: "请输入企业授权价格",
                        clearable: ""
                      }, {
                        append: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode("元")
                        ])),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", null, "企业Plus授权价格", -1)),
                      _createVNode(_component_el_input, {
                        modelValue: ruleForm.enterPlusPrice,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.enterPlusPrice) = $event)),
                        oninput: "value=value.replace(/[^\\d.]/g, '')",
                        placeholder: "请输入企业Plus授权价格",
                        clearable: ""
                      }, {
                        append: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("元")
                        ])),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "原创证明" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: "upload-demo",
                    "before-upload": (file) => beforeUpload(file, 'images'),
                    accept: ".jpg,.png",
                    drag: "",
                    action: upload_showImage.value,
                    multiple: "",
                    "on-success": onSuccessImages,
                    "file-list": ruleForm.images,
                    "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((ruleForm.images) = $event)),
                    "list-type": "picture"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createElementVNode("div", { style: {"width":"0.2rem","height":"0.2rem","background":"url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAACUJJREFUeF7tm0FWVEkQRTPpjeBKhAWIDMtRy6xcBbAKagaOqCHCAsCVWBuR7FPdohxPo/HjP4Iw8zLScyJe/Lzxr1W/LGrhBwIQeJJAhQ0EIPA0AQTh7oDALwggCLcHBBCEewACPgK8gvi40TUIAQQZZNEc00cAQXzc6BqEAIIMsmiO6SOAID5udA1CAEEGWTTH9BFAEB83ugYhgCCDLJpj+gggiI8bXYMQQJBBFs0xfQQQxMeNrkEIIMggi+aYPgII4uNG1yAEEGSQRXNMHwEE8XGjaxACCDLIojmmjwCC+LjRNQgBBBlk0RzTRwBBfNzoGoQAggyyaI7pI4AgPm50DUIAQQZZNMf0EUAQHze6BiGAIIMsmmP6CCCIjxtdgxBAkEEWzTF9BBDEx42uQQggyCCL5pg+Agji4ybtOlwsd+9L+buWsvsQXEv5eLVe3UkHETaZAIJMRqZrOFws9+5rPS+PxPgpfVNau7her051U0maQgBBptAS1h4slsel1hNTZGsnSGIiJS9CEDnS3wdOkuMhDkl+D/YZKhDkGaD+KvLb26pbz9id1vZ5LvGQ8/cgiJ+dq/PtYnnean3vaW6l3N1cnu17eunxEUAQHzd318G7D83dXMrm+vLs1Yx+WicSQJCJwOaUz3l79TCXt1lzNjC9F0GmM3N3vFks39f/PtZ1/yCIG52rEUFc2HxNCkFaa0c369WF7wromkoAQaYSm1GPIDPgvVArggSCR5BA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0ahSAikJYYBLFQylWDIIH7QJBA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0ahSAikJYYBLFQylWDIIH7QJBA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0ahSAikJYYBLFQylWDIIH7QJBA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0alV6Qw8Vyb3vWr6Xsis78YjE7pbxutb6fcwG1tYv7Uj7PycjS+1cpm6v16i7L9fzfdaQU5HCx3G2lHM+9mTKD59q+E9jU1u5qKR8zypJOkIPF8rjUesINNCCB1k6u16vTTCdPJQhyZLo1XuhakkmSRpDts8Z9rbcvtBbGJiKw09p+lrdbaQQ5ePfhS+ngQTzRffYnX8rm+vLsVYYDpBBE8fFnBphcg45AlleRFILw7KG7sbpJSvIskkKQt4vlOR/pdnNrSw6y/f+eT+vVkSRsRgiCzIBH6/MRQJBHbHmL9Xw32h+bzFusH6vjI94/9jZ+tgvnIf0R2u1XS77Wel5L+fd7V/wMT4CPeX++BXgVGV6K7wCyvHpsLyjFQ/oDGZ5FkKQkefZ42EQqQbYXhSQDS5JMjnSvIA+3Bl93H0uS7Ue6tZTTq/Vqk+3k6V5BHgPairL9flYPvyy1PRe/MPVju9tfltr+LcuXEp8SM7Ug2f41mXs9iu+ctdaObtari7nXQr+NAILYOEmqEESCMTQEQQJxI0ggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEsMglgo5apBkMB9IEggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEsMglgo5apBkMB9IEggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEsMglgo5apBkMB9IEggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEvM4WK5d1/rraX2qZrW2tHNenUxJ4NeOwEEsbOaXakQZKe1/av16m72xRBgIoAgJkyaosPFcve+1i9z0q4vz9jZHIATe4E9Edjc8jfvPtzWUvY8ObW1i0/r1ZGnlx4fAQTxcXN3zXkV4e2VG7u7EUHc6PyNB4vlcan1ZFJCayfX69XppB6KZxNAkNkIfQGTJEEOH2RBF4IIIHojvv2/yHEpZfeJjM1Oa0d8auUlPL8PQeYznJWwfSbZBnwtZW+nlNfbP7dSNjulfEaMWWglzQgiwUhIrwQQpNfNci4JAQSRYCSkVwII0utmOZeEAIJIMBLSKwEE6XWznEtCAEEkGAnplQCC9LpZziUhgCASjIT0SgBBet0s55IQQBAJRkJ6JYAgvW6Wc0kIIIgEIyG9EkCQXjfLuSQEEESCkZBeCSBIr5vlXBICCCLBSEivBBCk181yLgkBBJFgJKRXAgjS62Y5l4QAgkgwEtIrAQTpdbOcS0IAQSQYCemVAIL0ulnOJSGAIBKMhPRKAEF63SznkhBAEAlGQnolgCC9bpZzSQggiAQjIb0SQJBeN8u5JAQQRIKRkF4JIEivm+VcEgIIIsFISK8E/gGcNSUFdHk2qAAAAABJRU5ErkJggg==)","background-size":"100%","background-repeat":"no-repeat"} }, null, -1)
                        ])),
                        _: 1
                      }),
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "el-upload__text" }, [
                        _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333"} }, " 点击或拖拽文件到此处上传 "),
                        _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 图片大小20KB-10MB ")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["before-upload", "action", "file-list"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "size"]),
          _createElementVNode("div", {
            class: "dataBtn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (onSubmit(ruleFormRef.value)))
          }, "提交审核")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      style: {"border-radius":"12px"},
      top: "33px",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event)),
      "close-icon": "CircleCloseFilled",
      title: "选择推荐封面",
      width: "700"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              style: {"height":"329px","width":"100%","border-radius":"8px"},
              src: ruleForm.checkImg,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_19)
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleForm.showImages, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (ruleForm.checkImg = item),
                key: item
              }, [
                _createElementVNode("img", {
                  style: {"height":"65px","border-radius":"8px","width":"100%","cursor":"pointer"},
                  src: item,
                  alt: "",
                  srcset: ""
                }, null, 8, _hoisted_22)
              ], 8, _hoisted_21))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (dialogVisible.value = false)),
              style: {"cursor":"pointer","border-radius":"8px","border":"1px solid #86909C","width":"88px","height":"37px","color":"#333333","font-size":"14px","text-align":"center","line-height":"37px"}
            }, _cache[28] || (_cache[28] = [
              _createElementVNode("span", null, "取消", -1)
            ])),
            _createElementVNode("div", {
              onClick: saveClick,
              style: {"cursor":"pointer","border-radius":"8px","width":"88px","height":"37px","background":"#2978FF","color":"#ffffff","font-size":"14px","text-align":"center","line-height":"37px"}
            }, _cache[29] || (_cache[29] = [
              _createElementVNode("span", null, "保存", -1)
            ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})